import PropTypes from 'prop-types';
import React from 'react';
import { ComponentsProvider, BLOCKS_NAMESPACE } from '@niche-js/core/contexts';
import blockHeading from '@niche-js/block-heading';
import blockImage from '@niche-js/block-image';
import blockImages from '@niche-js/block-images';
import blockQuote from '@niche-js/block-quote';
import blockText from '@niche-js/block-text';
import blockEmbed from '@niche-js/block-embed';

var components = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Embed: blockEmbed,
    Heading: blockHeading,
    Image: blockImage,
    Images: blockImages,
    Quote: blockQuote,
    Text: blockText
});

/* eslint-disable react/jsx-props-no-spreading */
var propTypes = {
  children: PropTypes.node
};
var defaultProps = {
  children: null
};
var BlocksProvider = function BlocksProvider(props) {
  return /*#__PURE__*/React.createElement(ComponentsProvider, Object.assign({
    namespace: BLOCKS_NAMESPACE,
    components: components
  }, props));
};
BlocksProvider.propTypes = propTypes;
BlocksProvider.defaultProps = defaultProps;
var BlocksProvider$1 = BlocksProvider;

export { BlocksProvider$1 as default };
